<template>
  <WhitePage class="d-flex justify-content-center mb-3">
    <b-spinner class="m-5" label="Spinning"></b-spinner>
  </WhitePage>
</template>

<script>
import WhitePage from '@/components/WhitePage'
export default {
  components: {
    WhitePage
  },
  methods: {
    fetchFirst () {
      this.$store.dispatch('logout')
        .then(() => {
          if(this.$store.getters.test){
            this.$router.push({ path: '/change/test' })
          }else{
            this.$router.push({ path: '/' })
          }
        })
    }
  },
  mounted () {
    this.fetchFirst()
  }
}
</script>
